// frontend/src/components/supplier/vendorSuppliersFailureMessage.js

/**
 * What to tell the merchant about a run that failed. Only a store the
 * merchant can fix gets named copy; the backend sends an empty code for
 * everything else.
 */
export function vendorSuppliersFailureMessage(errorCode, t) {
  if (errorCode === 'vendor_suppliers_currency_missing') {
    return t('apiErrors.vendor_suppliers_currency_missing');
  }
  if (errorCode === 'vendor_suppliers_region_missing') {
    return t('apiErrors.vendor_suppliers_region_missing');
  }
  return t('supplierSetup.vendorSuppliers.runFailed');
}
